import React from "react"

export const LoadingXL = () => {
    return(
        <React.Fragment>
            <div className="flex flex-col align-middle h-16">
                <span className="fa-duotone text-theme fa-spinner-third fa-3x m-auto block fa-spin"></span>
            </div>
        </React.Fragment>
    )
}